import React, { useState } from 'react';
import { UIGameActionBoxBase } from '../../UIGameActionBoxBase.tsx';
import { DiceSelector } from './DiceSelector/DiceSelector.tsx';
import styles from './UIGameActionBoxPickDice.module.scss';
export const UIGameActionBoxPickDice = ({ onDiceSelected, onConfirm, isConfirmDisabled, isPortrait, ...baseProps })=>{
    const [selectedDice, setSelectedDice] = useState({
        dice1: 0,
        dice2: 0
    });
    const handleDiceSelected = (dicePair)=>{
        setSelectedDice((previousSelectedDice)=>{
            const newState = {
                ...previousSelectedDice,
                ...dicePair
            };
            onDiceSelected(newState);
            return newState;
        });
    };
    const areBothDiceSelected = selectedDice.dice1 !== 0 && selectedDice.dice2 !== 0;
    const shouldDisableConfirm = isConfirmDisabled ? isConfirmDisabled : !areBothDiceSelected;
    const handleConfirm = ()=>{
        if (areBothDiceSelected) onConfirm();
    };
    const bottomDiceRow = /*#__PURE__*/ React.createElement(DiceSelector, {
        disableHover: isPortrait !== null && isPortrait !== void 0 ? isPortrait : false,
        color: "white",
        onSelectDice: (diceValue)=>handleDiceSelected({
                dice2: diceValue
            }),
        className: styles.diceRow
    });
    return /*#__PURE__*/ React.createElement(UIGameActionBoxBase, {
        ...baseProps,
        footerContent: bottomDiceRow,
        isConfirmDisabled: shouldDisableConfirm,
        onConfirm: handleConfirm,
        ...isPortrait !== undefined && {
            isPortrait: isPortrait
        }
    }, /*#__PURE__*/ React.createElement(DiceSelector, {
        disableHover: isPortrait !== null && isPortrait !== void 0 ? isPortrait : false,
        color: "red",
        onSelectDice: (diceValue)=>handleDiceSelected({
                dice1: diceValue
            }),
        className: styles.diceRow
    }));
};
